import * as CryptoJS from 'crypto-js';

export function generateMD5(text: string): string {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  const md5 = CryptoJS.MD5(text) as string;
  return md5;
}
